"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5582,8662,7672],{

/***/ 9367:
/***/ (function(module) {



const denyList = new Set([
	'ENOTFOUND',
	'ENETUNREACH',

	// SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
	'UNABLE_TO_GET_ISSUER_CERT',
	'UNABLE_TO_GET_CRL',
	'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
	'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
	'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
	'CERT_SIGNATURE_FAILURE',
	'CRL_SIGNATURE_FAILURE',
	'CERT_NOT_YET_VALID',
	'CERT_HAS_EXPIRED',
	'CRL_NOT_YET_VALID',
	'CRL_HAS_EXPIRED',
	'ERROR_IN_CERT_NOT_BEFORE_FIELD',
	'ERROR_IN_CERT_NOT_AFTER_FIELD',
	'ERROR_IN_CRL_LAST_UPDATE_FIELD',
	'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
	'OUT_OF_MEM',
	'DEPTH_ZERO_SELF_SIGNED_CERT',
	'SELF_SIGNED_CERT_IN_CHAIN',
	'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
	'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
	'CERT_CHAIN_TOO_LONG',
	'CERT_REVOKED',
	'INVALID_CA',
	'PATH_LENGTH_EXCEEDED',
	'INVALID_PURPOSE',
	'CERT_UNTRUSTED',
	'CERT_REJECTED',
	'HOSTNAME_MISMATCH'
]);

// TODO: Use `error?.code` when targeting Node.js 14
module.exports = error => !denyList.has(error && error.code);


/***/ }),

/***/ 2909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FeaturedProducts; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9447);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4002);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(172);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5186);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2997);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7649);
/* harmony import */ var _components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3078);
/* harmony import */ var _components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9879);
/* harmony import */ var _components_Layout_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3666);
/* harmony import */ var _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9642);







swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"].use */ .Z.use([
    swiper_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
    swiper_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
    swiper_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z
]);
function FeaturedProducts(param) {
    var featuredProductsData = param.featuredProductsData, _title = param.title, title = _title === void 0 ? "" : _title, _bgColor = param.bgColor, bgColor = _bgColor === void 0 ? "" : _bgColor, _indexComponent = param.indexComponent, indexComponent = _indexComponent === void 0 ? "" : _indexComponent, _shouldShowChip = param.shouldShowChip, shouldShowChip = _shouldShowChip === void 0 ? false : _shouldShowChip, _url = param.url, url = _url === void 0 ? "" : _url;
    var pagination = {
        clickable: true
    };
    var navigation = {
        nextEl: "#produtos-swiper-button__next".concat(indexComponent),
        prevEl: "#produtos-swiper-button__prev".concat(indexComponent)
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout_WrapperContent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            backgroundColor: bgColor || _styles_designSystemColors__WEBPACK_IMPORTED_MODULE_4__/* .mglGray.mglGray200 */ .Ce.mglGray200,
            paddingOnBottom: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    texto: title || "Produtos em Alta",
                    color: "black",
                    showChip: shouldShowChip,
                    alignRight: shouldShowChip,
                    urlRedirect: url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative mt-4 [&_.container-swiper\\_\\_next]:-right-2 [&_.container-swiper\\_\\_prev]:-left-2 [&_.container-swiper]:z-[5] [&_.container-swiper]:opacity-100 [&_.container-swiper]:transition-opacity [&_.container-swiper]:duration-300 [&_.container-swiper]:ease-in-out [&_.swiper-pagination]:hidden desktop:[&_.swiper-pagination]:block [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:h-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:w-2 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:rounded-2xl [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:bg-black/20 [&_.swiper-pagination-bullet]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:w-[26px] [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:bg-mglBlue400 [&_span.swiper-pagination-bullet-active]:[&_.swiper-pagination]:[transition:background-color_0.3s_0s,_width_0.2s_0.3s]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_9__/* .Swiper */ .t, {
                            centeredSlidesBounds: true,
                            speed: 1000,
                            pagination: pagination,
                            navigation: navigation,
                            breakpoints: {
                                320: {
                                    slidesPerView: 1,
                                    slidesPerGroup: 1,
                                    spaceBetween: 16
                                },
                                768: {
                                    slidesPerView: 5,
                                    slidesPerGroup: 5,
                                    spaceBetween: 16
                                },
                                1660: {
                                    slidesPerView: 6,
                                    slidesPerGroup: 6,
                                    spaceBetween: 16
                                }
                            },
                            children: featuredProductsData.map(function(product) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_10__/* .SwiperSlide */ .o, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        title: product.titulo,
                                        image: product.imagem,
                                        url: product.url
                                    })
                                }, product.url);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-swiper container-swiper__prev",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "produtos-swiper-button__prev".concat(indexComponent),
                                className: "swiper-button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    width: "1.5em",
                                    height: "1.5em",
                                    preserveAspectRatio: "xMidYMid meet",
                                    viewBox: "0 0 24 24",
                                    style: {
                                        verticalAlign: "-0.125em",
                                        transform: "rotate(180deg)"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                        fill: "currentColor"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container-swiper container-swiper__next",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                id: "produtos-swiper-button__next".concat(indexComponent),
                                className: "swiper-button",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "aria-hidden": "true",
                                    focusable: "false",
                                    width: "1.5em",
                                    height: "1.5em",
                                    preserveAspectRatio: "xMidYMid meet",
                                    viewBox: "0 0 24 24",
                                    style: {
                                        verticalAlign: "-0.125em",
                                        transform: "rotate(360deg)"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z",
                                        fill: "currentColor"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 3666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2153);
/* harmony import */ var _components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2384);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9659);





function Card(param) {
    var title = param.title, url = param.url, image = param.image, _chipText = param.chipText, chipText = _chipText === void 0 ? "ver detalhes" : _chipText, _rumor = param.rumor, rumor = _rumor === void 0 ? false : _rumor, _onlyImage = param.onlyImage, onlyImage = _onlyImage === void 0 ? false : _onlyImage, _onlyImageAndText = param.onlyImageAndText, onlyImageAndText = _onlyImageAndText === void 0 ? false : _onlyImageAndText, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("group flex min-h-[220px] w-full cursor-pointer flex-col items-center rounded-lg bg-mglGray50 no-underline transition-all duration-300", onlyImage || onlyImageAndText ? "p-0" : "p-4", fullWidth ? "w-full" : ""),
            title: title,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("relative flex aspect-video justify-center [&>figure>div>img]:object-contain", fullWidth ? "w-full" : onlyImageAndText || onlyImage ? "max-h-[240px]" : "max-h-[120px] "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: image.url,
                            blurhash: image.blurhash,
                            width: onlyImage || onlyImageAndText ? null : 100,
                            height: onlyImage || onlyImageAndText ? null : 100,
                            alt: title
                        }),
                        rumor && !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute bottom-[9.5em] left-0 right-0 m-auto w-[3.375rem] rounded-lg bg-[#e8384f] text-center text-[0.6875rem] uppercase leading-loose text-mglGray50 hover:[&>div>span>svg>path>fill]:text-mglGray50",
                            children: "Rumor"
                        })
                    ]
                }),
                onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mt-4 font-medium text-mglGray900 tablet:mx-0 tablet:mb-0",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex h-10 items-center justify-center text-center text-sm font-medium text-mglGray900 no-underline",
                    children: title
                }),
                !onlyImage && !onlyImageAndText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Chip__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    texto: chipText,
                    chipSize: "medium",
                    posIcon: "chevron-right",
                    color: "black",
                    borderColor: "black",
                    title: title,
                    className: "group-hover:border group-hover:border-mglGray900 group-hover:bg-mglGray900 group-hover:text-mglGray50 [&>span>svg]:transition-colors group-hover:[&>span>svg]:text-mglGray50"
                })
            ]
        })
    });
}


/***/ }),

/***/ 9762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jx": function() { return /* binding */ findEditorialByExactVariantSlug; },
/* harmony export */   "r5": function() { return /* binding */ publicRouteFor; }
/* harmony export */ });
/* unused harmony exports EDITORIAL_ROUTES, findEditorialByVariant, findEditorialByPublicSlug, LEGACY_EDITORIA_SLUGS, monolithSlugFor, hasMonolithOverride */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9815);
// Fonte única do contrato de roteamento das editorias (CT UP, CT Eletro, CT Auto).
// Antes destes dados estarem centralizados, o mapeamento slug→rota vivia espalhado
// em quatro pontos (LEGACY_EDITORIA_SLUGS e MONOLITH_SLUG_OVERRIDES na página de
// categorias, EDITORIAL_PUBLIC_ROUTE e o campo `route` no FeaturedEditorialCategory),
// com risco de divergência entre SSR, render e navegação. Tudo que descreve "qual
// slug público, qual slug do monolito e como o bloco da home é buscado" nasce aqui.
//
// Fronteira: este módulo cuida só de slug/rota (dados puros, sem React). Cor e logo
// (apresentação) permanecem em `editorialCategoryProps` no FeaturedEditorialCategory.
// Variant de tema — identifica a editoria para cor, logo e regras de rota.

var EDITORIAL_ROUTES = [
    {
        variant: "ctup",
        slugPublic: "ctup",
        slugMonolith: "ctup",
        slugAliases: [],
        routeType: "id",
        homeRoute: "155778?merge=155790,155842"
    },
    {
        variant: "eletro",
        slugPublic: "ct-eletro",
        slugMonolith: "eletro",
        slugAliases: [
            "cteletro"
        ],
        routeType: "categoria",
        homeRoute: "eletro"
    },
    {
        variant: "ctauto",
        slugPublic: "ctauto",
        slugMonolith: "ctauto",
        slugAliases: [],
        routeType: "categoria",
        homeRoute: "ctauto"
    }, 
];
// Busca a editoria pelo variant de tema.
var findEditorialByVariant = function(variant) {
    return EDITORIAL_ROUTES.find(function(route) {
        return route.variant === variant;
    });
};
// Busca a editoria por um slug de entrada (URL pública ou alias legado).
var findEditorialByPublicSlug = function(slug) {
    return EDITORIAL_ROUTES.find(function(route) {
        return route.slugPublic === slug || route.slugAliases.includes(slug);
    });
};
// Busca a editoria quando o slug bruto coincide exatamente com o nome do variant
// (ctup/eletro/ctauto). Preserva o comportamento histórico da página de categorias,
// que só tratava esses três slugs como editoria de tema — sem capturar categorias
// legadas do CT UP como `hardware`/`games`.
var findEditorialByExactVariantSlug = function(slug) {
    return EDITORIAL_ROUTES.find(function(route) {
        return route.variant === slug;
    });
};
// Slugs de entrada que devem rotear direto para a editoria (merge monolito + Directus):
// os slugs públicos + aliases legados. Note que o slug do monolito (`eletro`) fica de
// fora de propósito — /eletro/ continua sendo categoria pura.
var LEGACY_EDITORIA_SLUGS = EDITORIAL_ROUTES.flatMap(function(route) {
    return [
        route.slugPublic
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(route.slugAliases));
});
var ref;
// Traduz um slug público do Fawkes para o slug que o monolito conhece.
// Retorna o próprio slug quando não há tradução (categoria comum).
var monolithSlugFor = function(slug) {
    var ref1;
    return (ref = (ref1 = findEditorialByPublicSlug(slug)) === null || ref1 === void 0 ? void 0 : ref1.slugMonolith) !== null && ref !== void 0 ? ref : slug;
};
// Indica se o slug público difere do slug do monolito (ex.: ct-eletro → eletro).
var hasMonolithOverride = function(slug) {
    var route = findEditorialByPublicSlug(slug);
    return Boolean(route && route.slugMonolith !== slug);
};
// URL pública (/ctup/, /ct-eletro/, /ctauto/) a partir do variant de tema.
var publicRouteFor = function(variant) {
    return findEditorialByVariant(variant).slugPublic;
};


/***/ }),

/***/ 3586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "PublicationTypes": function() { return /* binding */ PublicationTypes; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Categories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Home/FeaturedNews/index.tsx + 2 modules
var FeaturedNews = __webpack_require__(8768);
// EXTERNAL MODULE: ./src/components/Home/FeaturedLastNews/index.tsx + 6 modules
var FeaturedLastNews = __webpack_require__(2826);
// EXTERNAL MODULE: ./src/components/Layout/ItemListLastNews/styles.tsx
var styles = __webpack_require__(2747);
// EXTERNAL MODULE: ./src/lib/editorialRoutes.ts
var editorialRoutes = __webpack_require__(9762);
;// CONCATENATED MODULE: ./src/lib/listingLayout.ts
var CATEGORIES_WITHOUT_FEATURED_CAROUSEL = [
    "eletro",
    "games"
];
var shouldRenderFeaturedCarousel = function(slug) {
    return !CATEGORIES_WITHOUT_FEATURED_CAROUSEL.includes(slug);
};

// EXTERNAL MODULE: ./src/components/Home/FeaturedProducts/index.tsx
var FeaturedProducts = __webpack_require__(2909);
// EXTERNAL MODULE: ./src/components/Layout/index.tsx + 15 modules
var Layout = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/lib/sponsors.ts
var sponsors = __webpack_require__(6874);
;// CONCATENATED MODULE: ./src/pages/[categorias]/index.tsx











var __N_SSP = true;
var PublicationTypes;
(function(PublicationTypes) {
    PublicationTypes["noticias"] = "/noticias";
    PublicationTypes["analises"] = "/analises";
    PublicationTypes["dicas"] = "/dicas";
    PublicationTypes["tutoriais"] = "/tutoriais";
    PublicationTypes["o-que-e"] = "/o-que-e";
    PublicationTypes["materias"] = "/materias";
    PublicationTypes["colunas"] = "/colunas";
    PublicationTypes["editoriais"] = "/editoriais";
    PublicationTypes["listas"] = "/listas";
    PublicationTypes["artigos"] = "/artigos";
})(PublicationTypes || (PublicationTypes = {}));
function Categories(param) {
    var homeData = param.homeData, navBarData = param.navBarData, tagsData = param.tagsData, segmentacoes = param.segmentacoes, timelineData = param.timelineData, _schema = param.schema, schema = _schema === void 0 ? null : _schema, _isEditoria = param.isEditoria, isEditoria = _isEditoria === void 0 ? false : _isEditoria;
    var ref;
    var AdsTypeGenerators = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 8463).then(__webpack_require__.bind(__webpack_require__, 2444));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(2444)
                ];
            }
        },
        ssr: false
    });
    var router = (0,next_router.useRouter)();
    var categorias = router.query.categorias;
    var isPublicationType = Boolean(PublicationTypes[categorias.toString()]);
    var singleCategory = Array.isArray(categorias) ? categorias[0] : categorias;
    var editorialCategory = (0,sponsors/* getEditorialCategory */.PV)(singleCategory);
    var sponsoredCategory = (0,sponsors/* getSponsoredCategory */.Rt)(singleCategory);
    // Editoria de tema (ctup/eletro/ctauto) quando o slug bruto é exatamente o variant.
    var exactEditorial = typeof categorias === "string" ? (0,editorialRoutes/* findEditorialByExactVariantSlug */.Jx)(categorias) : undefined;
    var showFeaturedCarousel = shouldRenderFeaturedCarousel(singleCategory);
    var getRouteType = function() {
        // Editoria do Directus → o scroll pagina pelo endpoint de editoria.
        if (isEditoria) return "editoria";
        if (exactEditorial) return exactEditorial.routeType;
        if (categorias === "analises") return "tipo";
        return isPublicationType ? "tipoDePublicacao" : "categoria";
    };
    var getRoute = function() {
        if (isEditoria) return singleCategory;
        if (exactEditorial) return exactEditorial.homeRoute;
        if (categorias === "analises") return "analise";
        return categorias.toString();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        layoutData: {
            segmentacoes: segmentacoes,
            tagsData: tagsData,
            navBarData: navBarData,
            schema: schema
        },
        dataLayer: {
            contentType: "list",
            category: singleCategory
        },
        children: [
            showFeaturedCarousel && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedNews/* default */.Z, {
                featuredNewsData: timelineData.vitrine,
                editoria: timelineData.editoria,
                editorialCategory: editorialCategory
            }),
            categorias === "produtos" && /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProducts["default"], {
                featuredProductsData: homeData.data.produtos
            }),
            showFeaturedCarousel && (timelineData === null || timelineData === void 0 ? void 0 : (ref = timelineData.vitrine) === null || ref === void 0 ? void 0 : ref.length) > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* AdContainer */.g1, {
                noPadding: true,
                billboard: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdsTypeGenerators, {
                    type: "billboard/main/listing"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedLastNews["default"], {
                featuredLastNewsData: timelineData.timeline,
                rootPage: categorias,
                textTitle: timelineData.titulo,
                sponsoredCategory: sponsoredCategory,
                headingTag: "h1",
                routeType: getRouteType(),
                route: getRoute()
            })
        ]
    });
}


/***/ }),

/***/ 8662:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ axiosRetry; }
/* harmony export */ });
/* unused harmony exports namespace, isNetworkError, isRetryableError, isSafeRequestError, isIdempotentRequestError, isNetworkOrIdempotentRequestError, exponentialDelay */
/* harmony import */ var is_retry_allowed__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9367);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var namespace = 'axios-retry';
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isNetworkError(error) {
  return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
  error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
  is_retry_allowed__WEBPACK_IMPORTED_MODULE_0__(error); // Prevents retrying unsafe errors
}
var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isRetryableError(error) {
  return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isSafeRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isIdempotentRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isNetworkOrIdempotentRequestError(error) {
  return isNetworkError(error) || isIdempotentRequestError(error);
}
/**
 * @return {number} - delay in milliseconds, always 0
 */

function noDelay() {
  return 0;
}
/**
 * Set delayFactor 1000 for an exponential delay to occur on the order
 * of seconds
 * @param  {number} [retryNumber=0]
 * @param  {Error}  error - unused; for existing API of retryDelay callback
 * @param  {number} [delayFactor=100] milliseconds
 * @return {number} - delay in milliseconds
 */


function exponentialDelay() {
  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var error = arguments.length > 1 ? arguments[1] : undefined;
  var delayFactor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  var delay = Math.pow(2, retryNumber) * delayFactor;
  var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay

  return delay + randomSum;
}
/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @return {Object}
 */

function getCurrentState(config) {
  var currentState = config[namespace] || {};
  currentState.retryCount = currentState.retryCount || 0;
  config[namespace] = currentState;
  return currentState;
}
/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {AxiosRetryConfig} defaultOptions
 * @return {AxiosRetryConfig}
 */


function getRequestOptions(config, defaultOptions) {
  return _objectSpread(_objectSpread({}, defaultOptions), config[namespace]);
}
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */


function fixConfig(axios, config) {
  if (axios.defaults.agent === config.agent) {
    delete config.agent;
  }

  if (axios.defaults.httpAgent === config.httpAgent) {
    delete config.httpAgent;
  }

  if (axios.defaults.httpsAgent === config.httpsAgent) {
    delete config.httpsAgent;
  }
}
/**
 * Checks retryCondition if request can be retried. Handles it's retruning value or Promise.
 * @param  {number} retries
 * @param  {Function} retryCondition
 * @param  {Object} currentState
 * @param  {Error} error
 * @return {boolean}
 */


function shouldRetry(_x, _x2, _x3, _x4) {
  return _shouldRetry.apply(this, arguments);
}
/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 * @param {Function} [defaultOptions.onRetry=()=>{}]
 *        A function to get notified when a retry occurs
 */


function _shouldRetry() {
  _shouldRetry = _asyncToGenerator(function* (retries, retryCondition, currentState, error) {
    var shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error); // This could be a promise

    if (typeof shouldRetryOrPromise === 'object') {
      try {
        var shouldRetryPromiseResult = yield shouldRetryOrPromise; // keep return true unless shouldRetryPromiseResult return false for compatibility

        return shouldRetryPromiseResult !== false;
      } catch (_err) {
        return false;
      }
    }

    return shouldRetryOrPromise;
  });
  return _shouldRetry.apply(this, arguments);
}

function axiosRetry(axios, defaultOptions) {
  axios.interceptors.request.use(config => {
    var currentState = getCurrentState(config);
    currentState.lastRequestTime = Date.now();
    return config;
  });
  axios.interceptors.response.use(null, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (error) {
      var {
        config
      } = error; // If we have no information to retry the request

      if (!config) {
        return Promise.reject(error);
      }

      var {
        retries = 3,
        retryCondition = isNetworkOrIdempotentRequestError,
        retryDelay = noDelay,
        shouldResetTimeout = false,
        onRetry = () => {}
      } = getRequestOptions(config, defaultOptions);
      var currentState = getCurrentState(config);

      if (yield shouldRetry(retries, retryCondition, currentState, error)) {
        currentState.retryCount += 1;
        var delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
        // with circular structures: https://github.com/mzabriskie/axios/issues/370

        fixConfig(axios, config);

        if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
          var lastRequestDuration = Date.now() - currentState.lastRequestTime;
          var timeout = config.timeout - lastRequestDuration - delay;

          if (timeout <= 0) {
            return Promise.reject(error);
          }

          config.timeout = timeout;
        }

        config.transformRequest = [data => data];
        onRetry(currentState.retryCount, error, config);
        return new Promise(resolve => setTimeout(() => resolve(axios(config)), delay));
      }

      return Promise.reject(error);
    });

    return function (_x5) {
      return _ref.apply(this, arguments);
    };
  }());
} // Compatibility with CommonJS

axiosRetry.isNetworkError = isNetworkError;
axiosRetry.isSafeRequestError = isSafeRequestError;
axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
axiosRetry.exponentialDelay = exponentialDelay;
axiosRetry.isRetryableError = isRetryableError;
//# sourceMappingURL=index.js.map

/***/ })

}]);